import CertificateType from "../enums/CertificateType";
import CertificateSource from "../enums/CertificateSource";

const initialState = () => {
  return {
    lastKnownCertificateType: "pqc",
    lastKnownCertificateSource: null
  };
};
const certificateWizard = {
  namespaced: true,
  state: initialState(),
  getters: {
    getLastKnownCertificateType: state => state.lastKnownCertificateType,
    getLastKnownCertificateSource: state => state.lastKnownCertificateSource
  },
  mutations: {
    SET_LAST_KNOWN_CERTIFICATE_TYPE(state, lastKnownCertificateType) {
      state.lastKnownCertificateType = lastKnownCertificateType;
    },
    SET_LAST_KNOWN_CERTIFICATE_SOURCE(state, lastKnownCertificateSource) {
      state.lastKnownCertificateSource = lastKnownCertificateSource;
    }
  },
  actions: {
    //e.g. {type: "traditional", source: "from-new-keypair"}
    updateFromRouteMeta({ commit, getters }, { type, source }) {
      if (type != null) {
        commit("SET_LAST_KNOWN_CERTIFICATE_TYPE", type);

        // Prevent an illegal combination: PQC + FROM_CSR
        if (type === CertificateType.PQC && getters.getLastKnownCertificateSource === CertificateSource.FROM_CSR) {
          commit("SET_LAST_KNOWN_CERTIFICATE_SOURCE", null);
        }
      }
      if (source != null) {
        commit("SET_LAST_KNOWN_CERTIFICATE_SOURCE", source);
      }
    }
  }
};
export default certificateWizard;
